<template>
  <el-button @click="$store.commit('back')" v-if="step > 1">
    {{ text || 'Back' }} 
  </el-button>
</template>

<script>
const { mapState } = window.Vuex;
export default {
  props: ['text'],
  computed: {
    ...mapState(['step', 'config'])
  }
}
</script>